import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useSpotStatistics(parameters: Record<string, string>, enabled: boolean) {
  return useQuery({
    queryKey: ["spot-statistics", parameters],
    queryFn: () => api.getSpotStatistics(parameters),
    enabled,
    placeholderData: keepPreviousData,
  });
}
